import type { InitiativeState, ScheduleHealth } from '../../services/roadmapReports';
import { HEALTH_LABELS, healthExplanation } from './roadmapViewUtils';
import styles from './RoadmapV2.module.css';

interface Props {
  health: ScheduleHealth;
  /** When given, the chip explains its own rule with the row's dates on hover. */
  initiative?: InitiativeState;
}

export function HealthChip({ health, initiative }: Props) {
  const today = new Date().toISOString().slice(0, 10);
  return (
    <span
      className={`${styles.health} ${styles[`health_${health}`] ?? ''}`}
      title={initiative ? healthExplanation(initiative, today) : undefined}
    >
      {HEALTH_LABELS[health]}
    </span>
  );
}
